import { faFileExport } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Stack, Tooltip } from "@mui/joy";
import { memo } from "react";
import {
  ExportAudienceButton,
  ShareAudienceButton,
} from "features/mediaDataRoom/components/MediaDataRoomAudiencesTable/components";
import {
  useAdvertiserAudiences,
  useMediaDataRoom,
} from "features/mediaDataRoom/contexts";
import {
  type AudienceV3,
  type LookalikeAudienceV3,
  MediaDataRoomVersion,
  type RuleBasedAudienceV3,
} from "features/mediaDataRoom/models";

interface AudienceV3DrawerActionsProps {
  audience: AudienceV3;
}

const AudienceV3DrawerActions = memo<AudienceV3DrawerActionsProps>(
  ({ audience }) => {
    const {
      supportedFeatures: { canExportAudience },
    } = useMediaDataRoom(MediaDataRoomVersion.v3);
    const { canCurrentUserShareAudience } = useAdvertiserAudiences(
      MediaDataRoomVersion.v3
    );
    return (
      <Stack direction="row" justifyContent="flex-end" spacing={1}>
        {canExportAudience && !audience.isStale ? (
          <ExportAudienceButton audience={audience} menuPlacement="top" />
        ) : null}
        {canCurrentUserShareAudience(audience) ? (
          <ShareAudienceButton
            audience={audience as LookalikeAudienceV3 | RuleBasedAudienceV3}
            renderTrigger={(openShareAudienceDialog) => (
              <Tooltip title="Share audience">
                <Button
                  color="primary"
                  onClick={openShareAudienceDialog}
                  startDecorator={<FontAwesomeIcon icon={faFileExport} />}
                  sx={{ height: "fit-content" }}
                  variant="solid"
                >
                  Share audience
                </Button>
              </Tooltip>
            )}
          />
        ) : null}
      </Stack>
    );
  }
);

AudienceV3DrawerActions.displayName = "AudienceV3DrawerActions";

export default AudienceV3DrawerActions;
